import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';
import FileBase64 from 'react-file-base64';
import $ from 'jquery';
import SettingsPage from '../../views/SettingsPage/';

const GLOBAL = require('../../Globals');

class EditInstitution extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			insId : '',
			insName : '',
			addr : '',
			email : '',
			phone : '',
			mobile : '',
			fax : '',
			person : '',
			country : '',
			currency : '',
			language : '',
			insCode : '',
			timeZone : '',
			logo : '',
			url :'',
			_message : '',
			value : '',
			alertClass :'',
			posts : [],
			data : [],
			files: [],
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}
	
	getFiles(files){
		this.setState({ files: files })
	}
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
	}
	
	/** submit form **/
	onSubmit(e){
		e.preventDefault();
		 $("#showLoader").show();
		PostData('institution/edit',this.state).then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				alert('Institution Details Updated Successfully');
				this.setState({_redirect :true});
			}
			else{
		
				this.setState({
					_message:'Invalid Key',
					alertClass:'alert alert-danger'
				});
			}
		});
	}
	
	/** get institution details **/
	getdetails(){
	   $("#showLoader").show();
		GetData('institution/getinstitution').then((result) => {
			 $("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({
					insId : res[0]['id'],
					insName : res[0]['name'],
					addr : res[0]['address'],
					email : res[0]['email'],
					phone : res[0]['phone'],
					mobile : res[0]['mobile'],
					fax : res[0]['fax'],
					person : res[0]['contactperson'],
					country : res[0]['country'],
					currency : res[0]['currency'],
					language : res[0]['language'],
					inscode : res[0]['code'],
					timezone : res[0]['timezone'],
					url : res[0]['url'],
					logo : res[0]['logo'],
					facebook : res[0]['facebook'],
					instagram : res[0]['instagram'],
					twitter : res[0]['twitter'],
					youtube : res[0]['youtube'],
					linkedin : res[0]['linkedin'],
				});
			}
		});
	}
	
	/** This function wiil be call when page loading **/
	componentWillMount(){
		
		this.getcountry();
		this.getdetails();
	}
	
	/** get country **/
	getcountry(){
		GetData('home/getcountry').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}

	getBase64(file) {
	   var reader = new FileReader();
	   reader.readAsDataURL(file);
	   reader.onload = function () {
		 console.log(reader.result);
	   };
	   reader.onerror = function (error) {
		 console.log('Error: ', error);
	   };
	}
	
  render() {
	  
	var items = this.state.posts;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/settings/institutionview'/>);
	}
	
	return (
		<div>
		  <SettingsPage />
			<div className="animated fadeIn">
				<Row>
				  <Col md="12">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Card>
					  <form action="" method="post" role="form" id="editinsform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					  <Input type="hidden" name="insId" id="id" value={this.state.insId} onChange={this.onChange} />
					   <Input type="hidden" name="logo" id="logo" value={this.state.logo} onChange={this.onChange} />
						<CardHeader>
							<strong>Edit Institution Details</strong>
						</CardHeader>
						<CardBody>
						  <Row>
							<Col md="12">
							<Card>
							 <CardBody>
							 <Row>
							 <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Name</Label>
								  <Input type="text" name="insName" id="name" value={this.state.insName} required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="addr">Institution Address</Label>
								  <Input type="textarea" name="addr" id="addr" rows="2" onChange={this.onChange} required
									value={this.state.addr}/>
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="email">Email</Label>
								  <Input type="email" name="email" id="email" value={this.state.email} required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="admin">Admin Contact Person</Label>
								  <Input type="text" name="person" id="admin" required onChange={this.onChange} value={this.state.person}/>
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="country">Country</Label>
								  <select name="country" className="form-control" id="country" value={this.state.country} onChange={this.onChange}>
									<option value="">Select Country</option>
									{
										items.map(function (item) {
											return <option value={item.id }>{item.name}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="ctype">Currency Type</Label>
								  <Input type="text" name="currency"  id="ctype" required onChange={this.onChange} value={this.state.currency}/>
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="lang">Language</Label>
								  <Input type="text" name="language" id="lang" disabled onChange={this.onChange} value={this.state.language} />
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="phone">Phone</Label>
								  <Input type="text" name="phone" id="phone" value={this.state.phone} required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="mobile">Mobile</Label>
								  <Input type="text" name="mobile" id="mobile" value={this.state.mobile} required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							   <Col md="4">
								<FormGroup>
								  <Label htmlFor="fax">Institution Fax</Label>
								  <Input type="text" name="fax" id="fax" value={this.state.fax} required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="code">Institution Code(This code will be used as the prefix for student admission number)</Label><br></br>
								  <input type="checkbox" name="insCodetic" required onChange={this.onChange} checked/>
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="icode">Institution Code</Label>
								  <Input type="text" name="inscode" id="icode" value={this.state.inscode} required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							   <Col md="6">
								<FormGroup>
								  <Label htmlFor="timezone">Timezone</Label>
								  <Input type="text" name="timezone" id="timezone" value={this.state.timezone} required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="2">
								<Card>
									<CardBody>
										<img src={this.state.url} id="editlogo" />
									</CardBody>
								</Card>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="logo">Upload Logo</Label>
								  <FormGroup>
									<FileBase64 onDone={ this.getFiles.bind(this) } />
								  </FormGroup>
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="facebook">Facebook Link</Label>
								  <Input type="text" name="facebook" id="facebook" value={this.state.facebook} onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="instagram">Instagram Link</Label>
								  <Input type="text" name="instagram" id="instagram" value={this.state.instagram} onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="twitter">Twitter Link</Label>
								  <Input type="text" name="twitter" id="twitter" value={this.state.twitter} onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="linkedin">Linked In</Label>
								  <Input type="text" name="linkedin" id="linkedin" value={this.state.linkedin} onChange={this.onChange} />
								</FormGroup>
							  </Col>
							   <Col md="6">
								<FormGroup>
								  <Label htmlFor="youtube">Youtube Link</Label>
								  <Input type="text" name="youtube" id="youtube" value={this.state.youtube} onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  </Row>
							  </CardBody>
							 </Card>
							 </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary" className="btn-pull-right"><i className="fa fa-dot-circle-o"></i> Update</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default EditInstitution;


// WEBPACK FOOTER //
// ./src/settings/Institution/EditInstitution.js